import z from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { OptionalPhoneNumber } from '../Phone';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';

export const Foreclosure = z.object({
  id: zodBrandedUuid<ForeclosureId>(),
  referralDate: zodDateOrString,
  firstLegalActionDate: zodDateOrString.optional(),
  lawFirm: z.string().optional(),
  attorneyName: z.string().optional(),
  attorneyPhone: OptionalPhoneNumber,
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
  endDate: zodDateOrString.optional(), // date loan status changes out of foreclosure
});
export type Foreclosure = z.infer<typeof Foreclosure>;
